import React from "react";
import CardSlider from "./CardSlider";

function Packages() {
    return (
        <div>
             <div style={{ backgroundColor: '#EEF5FF' }}>
              <CardSlider/>
              <br></br>
              <br></br>
            </div>

        </div >
    );
}

export default Packages;